/**
 * 课程内容
 * @description 课程内容
 * @author yly
 * @date 2023-9-12
 *  */
import React from 'react';
import { connect } from 'dva';
import ScheduleList from "./listSelect/scheduleList";
import ExamList from "./listSelect/examList";
import { Spin, Card, Row, Col, Divider, Form, Input, Pagination } from 'antd'
import { AuditForm } from './components'
import './index.less'
import { framework_tool, component_tool, utils_tool, } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer, WizFileUpload } = framework_tool;
let {
  WizSelect,
  WizTreeSelectList, Wizmessage, WizForm, WizButton, WizModal, WizIcon, WizDropdown, WizMenu, WizTable, WizCustomSteps, WizAntdForm, WizBraftEditor

} = component_tool;
const WizItem = WizMenu.Item

class WizClassifySelect extends WizContainer {

  componentName = 'WizClassifySelect';

  constructor(props) {
    super(props);
    this.state = {
      stateSelects: props.initSelects || [],
      data: {},
      rowData: new Date().getTime(),
      programContent: [],
      tableList: [],
      selectedExamRows: [],//选择的课程考试
      selectedScheduleRows: [], //选择的课件
      current: 1,
      versionInfo: {}
    }
  }

  static defaultProps = {
    onChange: () => { },//点击modal 确定的回调方法
    value: [],//已选数据,
    modalProps: {},//modal的参数
    selectProps: {},//输入框的参数
    wizTreeSelectListProps: {},//WizTreeSelectList的参数
    apiProps: {},//调用分类接口的参数
    apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
    returnKey: false,//onChange返回数据是否需要key，默认返回对象
  };


  /**
   * 初始化时根据record判断是新增还是编辑
   */
  _componentDidMount() {
    let { apiProps, apiPath } = this.props
    this.getApplicationList()
    this.getNewConfirmedInfo()
  }
  getNewConfirmedInfo = (params = {}) => {
    let { record } = this.props
    this.doActions([
      {
        path: 'courseApplication/newConfirmedInfo',
        payload: {
          key: `courseApplication@newConfirmedInfo`,
          apiParams: { programId: record.id, ...params }
        }
      }
    ])
  }
  getApplicationList = (params = {}) => {
    let { record } = this.props
    this.doActions([
      {
        path: 'courseApplication/getListByPage',
        payload: {
          key: `courseApplication@getListByPage`,
          apiParams: {statusList:[0,1,3], programId: record.id, ...params }
        }
      }
    ])
  }
  putOperate = (values) => {
    this.doAction({
      path: "courseApplication/operate",
      payload: {
        key: "courseApplication@operate",
        apiParams: values
      }
    })
  }
  propsAndStateOnChange = {
    applicationList: this._applicationListOver.bind(this),
    operateData: this._operateDataOver.bind(this),
    newConfirmedInfo: this._newConfirmedInfoOver.bind(this),
  }
  _newConfirmedInfoOver(nextProps, nextState) {
    const { newConfirmedInfo } = nextProps;
    if (newConfirmedInfo.success) {
      nextState.versionInfo = newConfirmedInfo.data
      console.log(nextState.versionInfo, 'nextState.versionInfo')
      return true;
    } else {
      // wizNotice.error(newConfirmedInfo.msg);
    }
    return false;
  }

  _operateDataOver(nextProps, nextState) {
    const { operateData } = nextProps;
    const { current } = nextState;
    if (operateData.success) {
      wizNotice.success('操作成功');
      this.getApplicationList({ current: current })
      return true;
    } else {
      wizNotice.error(operateData.msg);
    }
    return false;
  }

  _applicationListOver(nextProps, nextState) {
    if (nextProps.applicationList.code == 1) {
      if (nextProps.applicationList.data) {
        console.log(nextProps.applicationList.data, 'nextProps.applicationList.data')
        nextState.programContent = nextProps.applicationList.data
        return true;

      }
    }
    return true;
  }
  handleMenuClick(e) {
    let { programContent } = this.state
    let data = {}
    data.orderNum = programContent ? programContent.length + 1 : 1
    data.contentType = e.key === 'programAdd' ? 0 : 1
    data.fileType = 0
    this.setState({ scheduleModalVisible: true, data: data, addType: 'add' })
  }
  formatList = (content) => {
    content.forEach(item => {
      item.fileId = item.fileId[0]?.fileId
    })
    return content
  }
  submit = (data) => {
    let { onChange } = this.props
    console.log('提交  =====>', data)
    let content = [...this.state.programContent]
    if (content.findIndex(x => x.orderNum == data.orderNum) > -1) {
      content = content.filter(x => x.orderNum != data.orderNum)
      content.push(data)
    } else {
      content.push(data)
    }
    console.log(content, 'content')
    this.setState({ programContent: content, scheduleModalVisible: false })
    onChange && onChange(this.formatList(content))
  }
  cancel = () => {
    this.setState({ scheduleModalVisible: false })
  }
  /**选择课件模态框 */
  scheduleListModal() {

    const { data, addType } = this.state

    return (
      <WizModal
        visible={this.state.scheduleModalVisible}
        onCancel={() => this.setState({ scheduleModalVisible: false })}
        footer={null}
        style={{ minWidth: 1000 }}
        title={`${!data.isRead ? addType == 'add' ? '新增' : '编辑' : '查看'}课程内容-${data.contentType == 0 ? '课件' : '考试'}`}
        key={this.state.scheduleListModalKey}
      >
        <AuditForm data={data} submit={this.submit} cancel={this.cancel} />
      </WizModal>
    )
  }

  editRecord = (record) => {
    this.setState({ data: record, scheduleModalVisible: true, addType: 'edit' })
  }
  deleteRow = (record) => {
    let content = [...this.state.programContent]
    content = content.filter(x => x.orderNum != record.orderNum)
    this.setState({ programContent: content })
  }
  lookRecord = (record) => {
    if (record.applyType == 0) {
      this.jumpPage('push', '/course/applicationView', { id: record.id })
    } else {
      this.jumpPage('push', '/course/applicationUpdateView', { id: record.id })
    }
  }
  /**上移下移 行数据 */
  moveUpAndDown(record) {
    let { onChange } = this.props

    const programContent = [...this.state.programContent];

    const indexOf = programContent?.indexOf(record);
    // 是否上移
    const hasMoveUp = indexOf > 0

    console.log('moveUpAndDown --->', programContent, record, indexOf, hasMoveUp)
    if (!programContent?.length || (hasMoveUp && indexOf <= 0) || (!hasMoveUp && indexOf === programContent.length - 1)) {
      console.log('操作失败,请检查数据.可能原因无数据、已经到顶了、已经到底了')
      return;
    }
    // 数据位置替换
    programContent.splice(indexOf, 1)
    if (hasMoveUp) {
      programContent.splice(indexOf - 1, 0, record)
    } else {
      programContent.splice(indexOf + 1, 0, record)
    }
    // 重新计算排列顺序
    const neoProgramContent = programContent.map(({ orderNum, ...item }, index) => ({ ...item, orderNum: index + 1 }))
    // 保存变更到state
    this.setState({
      programContent: neoProgramContent,
      time: new Date().getTime()
    })
    onChange && onChange(this.formatList(neoProgramContent))

  }
  changePage = (page) => {
    this.setState({ current: page })
    this.getApplicationList({ current: page })
  }
  operateFun = (record, operateStatus) => {
    WizModal.confirm({
      title: operateStatus == 0 ? '您正在创建此申请的在线课程，是否确认？' :
        (operateStatus == 1 ? '您正在做确认申请操作，是否确定？'
          :
          '您正在做取消申请操作，是否确定？'),
      onOk: () => {
        this.putOperate({ id: record.id, operateStatus: operateStatus })
      },
      onCancel() { }
    })
  }
  _render() {
    let { programContent, versionInfo } = this.state
    const { getFieldDecorator } = this.props.form
    console.log(this.props.form, 'this.props.form777')
    const columns = [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "申请类型",
        key: "applyType",
        dataIndex: "applyType",
        width: 120,
        render: (text, record) => (
          text == 0 ? '新课程申请' : (text == 1 ? '课程内容更新' : '初始课程')
        ),

      },
      {
        title: "新版本号",
        key: "versionNumber",
        dataIndex: "versionNumber",
        width: 120,

      },
      {
        title: "状态",
        key: "status",
        dataIndex: "status",
        width: 120,
        render: (text, record) => (
          text == 0 ? '已申请' : (text == 1 ? '已确认申请' :(text == 2?'已取消申请':'') )
        ),
      },
      {
        title: "申请人",
        key: "applicantFullName",
        dataIndex: "applicantFullName",
        width: 120,
      },
      {
        title: "培训公司",
        key: "trainCompanyName",
        dataIndex: "trainCompanyName",
        width: 160,
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 160,
      },
      {
        title: '确认申请时间',
        dataIndex: 'handleTime',
        key: 'handleTime',
        width: 160,
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            {record.applyType != 2 ? <a onClick={e => this.lookRecord(record)}> 查看</a> : null}
            {record.status == 0 ? <a onClick={e => this.operateFun(record, 1)}> 确认申请</a> : null}
          </span>
        ),
      },
    ];
    console.log(this.state.programContent, 'programContent')
    return (
      <>
        <div className="table-row" key={'program_content_' + this.state.time}>
          {versionInfo.id? <Row className='loc-version-box'>
            <Col span={9}>课程名称：{versionInfo.programName}</Col>
            <Col span={9}>课程编码：{versionInfo.programScoId}</Col>
            <Col span={6}>当前版本：{versionInfo.versionNumber}</Col>
          </Row>:null}
          <WizTable pagination={false} columns={columns} dataSource={this.state.programContent.records} />
          <div className='pagination-box'>
            <Pagination onChange={this.changePage} current={programContent.current} pageSize={10} total={programContent.total}></Pagination>
          </div>
        </div>
        {this.scheduleListModal()}
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { courseApplication } = state;
  const { apiProps } = ownProps;
  const applicationList = modelUtils.getModelEntity(courseApplication, `courseApplication@getListByPage`);
  const newConfirmedInfo = modelUtils.getModelEntity(courseApplication, `courseApplication@newConfirmedInfo`);
  const operateData = modelUtils.getModelEntity(courseApplication, 'courseApplication@operate');
  const load = modelUtils.getLoadingState(state, "courseApplication");

  return {
    applicationList,
    newConfirmedInfo,
    operateData,
    ...load
  }
};

const options = { withRef: true };
export default Form.create()(connect(mapStateToProps, null, null, options)(WizClassifySelect));

